<template lang="pug">
div.wrap-demo-test-scene.relative
  //- div.wrap-controller-area.px12.py12
    AtomHairWindChanger(v-if="clock && targetObject"
    :isPhotoStudio="true" :clock="clock"
    :targetObject="targetObject"
    @updateHairWind="updateHairWind")
  //- div(style="width: 100%; height: 420px;")
    ItemGltfUploader
  //- input(ref="inputFile" type="file" multiple webkitdirectory @change="changeFile")
  //- input(ref="inputFile" type="file" multiple @change="changeFile")
  //- AssetUploader(:assetType="{ type: '3d_stage', name: '3Dステージ', icon: 'mdi-bank' }")
  div(ref="wrapCanvas")

  div.wrap-slider.absolute.b4.r12
    a(@click="$router.push('/home')") to home
    span.block gltfEmissive: {{gltfEmissive}}
    //- v-slider(v-model="gltfEmissive"
      :min="0" :max="16777215" :step="10000")
    v-slider(v-model="gltfEmissive"
      :min="0x000000" :max="0xffffff" :step="0xffffff / 15")
    //- a(@click="updateMaterialEmissive({ gltf, emissiveColor: 0x000000 })") change mat
    v-slider(v-model="ambientLightIntensity"
      :label="`al${ambientLightIntensity}`" min="0" max="10" step="0.1")
    //- v-slider(v-model="directionalLightIntensity"
    //-   :label="`dl：${directionalLightIntensity}`" min="0" max="10" step="0.1")
    //- v-slider(v-model="cameraAspect.w"
    //-   :label="`as.w${cameraAspect.w}`" min="0.1" max="10" step="0.1")
    //- v-slider(v-model="cameraAspect.h"
    //-   :label="`as.h${cameraAspect.h}`" min="0.1" max="10" step="0.1")
    //- v-slider(v-model="cameraPosZ"
    //-   :label="`cpz${cameraPosZ}`" min="0.0" max="1.5" step="0.01")
    //- v-slider(v-model="cameraRotateZ"
    //- :label="`crz${cameraRotateZ}`" min="0.0" max="1" step="0.01")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-demo-test-scene {
  width: 100%;
  min-height: $device_height;
  .wrap-controller-area {
    position: fixed;
    top: 12px; right: 12px;
    width: 90%; max-width: 320px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 3px;
  }
  .wrap-slider {
    width: 520px;
    background: rgba(255, 255, 255, 0.3);
  }
}
</style>

<script>
/* eslint-disable */
// import * as THREE from 'three'
import Stats from 'three/examples/jsm/libs/stats.module'
import * as THREE from 'three'
import { VRM, VRMSchema, VRMMaterialImporter, VRMImporter } from '@pixiv/three-vrm'
import studioManager from '@/components/mixin/studioManager'
import vrmManager from '@/components/mixin/vrmManager'
import gltfManager from '@/components/mixin/gltfManager'
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter'
// import { DRACOExporter } from 'three/examples/jsm/exporters/DRACOExporter'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
// import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
// import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
// import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
// import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js'
// import { ToneShader } from '@/shader/Tone'
// // import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader.js'
// import { ComicalConvertionShader } from '@/shader/comicalConvertion'
// import { createToonShaderMaterial } from '@/shader/toon'
// import { OutlineEffect } from '@/shader/OutlineEffect'
// import { CustomOutlinePass } from '@/shader/CustomOutlinePass'
// import { SelectiveCustomOutlinePass } from '@/shader/SelectiveCustomOutlinePass'
// import { OutlineMesh } from 'three-line-outline'
import AssetUploader from '@/components/shared/AssetUploader'
import ItemGltfUploader from '@/components/item/asset-uploader/ItemGltfUploader'
import { WebIO } from '@gltf-transform/core'
import { DracoMeshCompression } from '@gltf-transform/extensions'
import { handleDragOver, handleFileSelect } from '@/plugins/GLTFtoGLB'
/* globals DracoEncoderModule */
/* globals DracoDecoderModule */
import { OutlineMesh } from 'three-line-outline'
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
// import { LineSegments2 } from 'https://cdn.skypack.dev/three@0.130.1/examples/jsm/lines/LineSegments2.js'
import AtomHairWindChanger from '@/components/atom/studio/AtomHairWindChanger'

export default {
  mixins: [studioManager, vrmManager, gltfManager],
  components: {
    AssetUploader,
    ItemGltfUploader,
    AtomHairWindChanger
  },
  data () {
    return {
      renderer: null, scene: null, outlinedScene: null, clock: null, frameRateCount: 0,
      camera: null,
      cameraAspect: { w: 1, h: 1 },
      initialCameraPos: { x: 0, y: 0, z: 3.5 }, initialCameraRotate: { x: 0, y: 0, z: 0},
      cameraPosZ: 0, cameraRotateZ: 0,
      orbitControls: null, light: null,
      effect: null,
      directionalLight: null, directionalLightIntensity: 1,
      ambientLight: null, ambientLightIntensity: 1,
      gltf: null, gltfEmissive: 0x666666,
      // composer: null, renderPass: null, colorPass: null,
      // comicalConvertPass: null, effectFXAA: null, selectiveCustomOutline: null,
      thresholdPass: null, edgeDetectionPass: null,
      vrm: null, targetObject: null,
      stats: null,
      onResizeTimer: null
    }
  },
  watch: {
    ambientLightIntensity () {
      this.ambientLight.intensity = this.ambientLightIntensity
    },
    directionalLightIntensity () {
      this.light.intensity = this.directionalLightIntensity
    },
    cameraAspect: {
      handler () {
        // const w = this.canvasSize.width
        // const h = this.canvasSize.height
        // const fullWidth = w * this.cameraAspect.w
        // const fullHeight = h * this.cameraAspect.h
        // this.camera.setViewOffset(fullWidth, fullHeight, w * 0, h * 0, w, h)

        this.camera.aspect = this.canvasSize.width * this.cameraAspect.w / this.canvasSize.height * this.cameraAspect.h
        this.camera.updateProjectionMatrix()
      },
      deep: true
    },
    cameraPosZ () {
      this.camera.position.set(
        this.initialCameraPos.x,
        this.initialCameraPos.y,
        this.initialCameraPos.z - this.cameraPosZ
        )
    },
    cameraRotateZ () {
      this.camera.rotation.set(
        this.initialCameraRotate.x,
        this.initialCameraRotate.y,
        this.initialCameraRotate.z - this.cameraRotateZ
        )
    },
    gltfEmissive () {
      this.updateMaterialEmissive({
        // gltf: this.gltf,
        object: this.gltf.scene,
        emissiveColor: this.gltfEmissive
      })
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize)

    this.canvasSize = {
      width: this.$el.clientWidth,
      height: this.$el.clientHeight
    }
    this.stats = Stats()
    document.body.appendChild(this.stats.dom)
    this.initializeScene()
  },
  async beforeDestroy () {
    this.disposeScene({ renderer: this.renderer, scene: this.scene })
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    async initializeScene () {
      this.scene = new THREE.Scene()
      this.outlinedScene = new THREE.Scene()
      // this.scene.background = new THREE.Color(0x000000)
      this.scene.updateMatrixWorld(true)
      
      // レンダラーの設定
      this.renderer = this.createRenderer({ 
        size: { width: this.canvasSize.width, height: this.canvasSize.height }
      })
      // this.renderer.autoClear = false

      // this.renderer.gammaOutput = true
      // this.renderer.physicallyCorrectLights = true
      // this.renderer.outputEncoding = THREE.sRGBEncoding
      // this.renderer.toneMapping = THREE.ACESFilmicToneMapping

      // this.renderer.toneMappingExposure = 1.0
      // this.renderer.shadowMap.enabled = true
      // this.renderer.gammaFactor = 0

      // this.renderer.setClearColor(0x000000, 1)
      // this.renderer.setClearColor(0xffffff, 1)

      this.$refs.wrapCanvas.appendChild(this.renderer.domElement)

      this.camera = new THREE
        .PerspectiveCamera(35, this.canvasSize.width / this.canvasSize.height, 0.1, 128)
      // this.camera.position = new THREE.Vector3(0, 1.5, 3.5)
      this.camera.position = new THREE.Vector3(0, 0.2, 3.0)
      
      // this.camera.position = new THREE.Vector3(0, 1.0, -3.5)

      // カメラコントーロールの設定
      this.orbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      // this.orbitControls = new OrbitControls(this.camera, this.renderer.domElement)
      this.orbitControls.target = new THREE.Vector3(0, 0.2, 0)
      // this.orbitControls.target = new THREE.Vector3(0, 1.5, 0)
      this.orbitControls.screenSpacePanning = true
      this.orbitControls.listenToKeyEvents(window)
      this.orbitControls.keys = {
        LEFT: 'ArrowLeft', //left arrow
        UP: 'ArrowUp', // up arrow
        RIGHT: 'ArrowRight', // right arrow
        BOTTOM: 'ArrowDown' // down arrow
      }
      this.orbitControls.update()

      // ライトの設定
      this.light = new THREE.DirectionalLight(0xffffff)
      this.light.position = new THREE.Vector3(1, 1, 1)
      this.light.position.normalize()
      this.light.intensity = this.defaultDirectionalLightIntensity
      this.directionalLightIntensity = this.defaultDirectionalLightIntensity
      // this.light.castShadow = true
      // this.light.shadow.mapSize.height = 4096
      // this.light.shadow.mapSize.width = 4096
      this.scene.add(this.light)
      this.outlinedScene.add(new THREE.DirectionalLight(0xffffff))

      this.ambientLight = new THREE.AmbientLight(0xffffff)
      this.ambientLight.intensity = this.defaultAmbientLightIntensity
      this.ambientLightIntensity = this.ambientLight.intensity
      this.scene.add(this.ambientLight)
      this.outlinedScene.add(new THREE.AmbientLight(0xffffff))

      // 座標軸を表示
      const axesHelper = new THREE.AxesHelper(0.5)
      console.log('axesHelper:', axesHelper)
      this.scene.add(axesHelper)

      // var outline_shader = {
      //   uniforms: {
      //       "linewidth":  { type: "f", value: 0.003 },
      //   },
      //   vertex_shader: [
      //       "uniform float linewidth;",
      //       "void main() {",
      //           "vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );",
      //           "vec4 displacement = vec4( normalize( normalMatrix * normal ) * linewidth, 0.0 ) + mvPosition;",
      //           "gl_Position = projectionMatrix * displacement;",
      //       "}"
      //   ].join("\n"),
      //   fragment_shader: [
      //       "void main() {",
      //           "gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);",
      //       "}"
      //   ].join("\n")
      // }
      // var outline_material = new THREE.ShaderMaterial({
      //   uniforms: THREE.UniformsUtils.clone(outline_shader.uniforms),
      //   vertexShader: outline_shader.vertex_shader,
      //   fragmentShader: outline_shader.fragment_shader
      // })

      // const boxGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
      // const boxMaterial = outline_material // new THREE.MeshBasicMaterial({color: 0x99ffff})
      // // const boxMaterial = new THREE.MeshBasicMaterial({color: 0x000000})
      // const box = new THREE.Mesh(boxGeometry, boxMaterial)
      // box.position.set(0.0, 0.0, 0.0)
      // this.scene.add(box)


      // const boxOutline = new OutlineMesh(box)
      // this.scene.add(boxOutline)

      // const boxEdges = new THREE.EdgesGeometry(boxGeometry)
      // const lineMaterial = new THREE.LineBasicMaterial({ color: 0x000000 })
      // const boxLine = new THREE.LineSegments(boxEdges, lineMaterial)
      // boxLine.position.copy(box.position)
      // this.scene.add(boxLine)


      // const container = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17fbbe74fa8166.draco.gltf?alt=media&token=66ceb18a-e192-4aba-95a2-d07b580964e7'
      // const loader = new GLTFLoader();
      // const dracoLoader = new DRACOLoader()
      // const decoderPath = 'https://www.gstatic.com/draco/versioned/decoders/1.4.1/'
      // dracoLoader.setDecoderPath(decoderPath)
      // loader.setDRACOLoader(dracoLoader)
      
      // 3Dモデルを読み込む
      // loader.load(container, (gltf) => {
      //   const model = gltf.scene;
      //   this.scene.add(model);

      //   // シェーダーマテリアルを作成する
      //   const material = new THREE.ShaderMaterial({
      //     uniforms: {
      //       time: { value: 0.0 },
      //       edgeColor: { value: new THREE.Color(0xff0000) },
      //       edgeWidth: { value: 1.5 },
      //       modelColor: { value: new THREE.Color(0x000000) },
      //     },
      //     vertexShader: `
      //       uniform float time;
      //       varying vec3 vNormal;
      //       void main() {
      //         vNormal = normal;
      //         gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      //       }
      //     `,
      //     fragmentShader: `
      //       uniform float time;
      //       uniform vec3 edgeColor;
      //       uniform float edgeWidth;
      //       uniform vec3 modelColor;
      //       varying vec3 vNormal;
      //       void main() {
      //         float edge = 1.0 - smoothstep(0.0, edgeWidth, length(vNormal));
      //         vec3 color = mix(modelColor, edgeColor, edge);
      //         gl_FragColor = vec4(color, 1.0);
      //       }
      //     `,
      //   });
      //   material.depthTest = true;
      //   material.depthWrite = true;


      //   // モデルのマテリアルをシェーダーマテリアルに置き換える
      //   gltf.scene.traverse(function (child) {
      //     if (child instanceof THREE.Mesh) {
      //       child.material = material;
      //     }
      //   });
      // });

      // PostProcessing by mixim
      this.initializeComposer({
        renderer: this.renderer, scene: this.scene, camera: this.camera
      })

      /*
      // PostProcessing
      this.composer = new EffectComposer(this.renderer)
      this.renderPass = new RenderPass(this.scene, this.camera)
      this.composer.addPass(this.renderPass)

      // const renderPass = new RenderPass(this.scene, this.camera)
      // renderPass.renderToScreen = true
      // // renderPass.clear = false
      // // renderPass.clearDepth = true
      
      // const renderPassForOutlined = new RenderPass(this.outlinedScene, this.camera)
      // renderPassForOutlined.renderToScreen = true
      // // renderPassForOutlined.clear = false
      // // renderPassForOutlined.clearDepth = true
      
      // this.composer = new EffectComposer(this.renderer)
      // this.composer.addPass(renderPass)
      // // this.composer.addPass(renderPassForOutlined)

      // AssetLineArtEditorの域値のデフォルトパラメーター
      // grayScaleParam: {
      //   areaValues: [60, 120],
      //   pallete: [0, 178, 255]
      // }
      // 3色変換
      const thresholdShaderParams = {
        uniforms: ToneShader.uniforms,
        vertexShader: ToneShader.vertex,
        fragmentShader: ToneShader.fragment
      }
      this.thresholdPass = new ShaderPass(thresholdShaderParams)
      this.thresholdPass.renderToScreen = true
      // this.composer.addPass(this.thresholdPass)

      // 3色 + 線画変換
      this.comicalConvertPass = new ShaderPass(ComicalConvertionShader)
      this.comicalConvertPass.uniforms['resolution'].value.x = window.innerWidth * window.devicePixelRatio
      this.comicalConvertPass.uniforms['resolution'].value.y = window.innerHeight * window.devicePixelRatio
      this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = 0.77059
      this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = 0.40000
      this.comicalConvertPass.renderToScreen = true
      // this.composer.addPass(this.comicalConvertPass)

      // const edgeDetectionShaderParams = {
      //   uniforms: edgeDetectionShader.uniforms,
      //   vertexShader: edgeDetectionShader.vertex,
      //   fragmentShader: edgeDetectionShader.fragment
      // }
      // this.edgeDetectionPass = new ShaderPass(edgeDetectionShaderParams)
      // this.edgeDetectionPass.renderToScreen = true
      // this.composer.addPass(this.edgeDetectionPass)

      // CustomOutlinePass
      // const customOutline = new CustomOutlinePass(
      //   new THREE.Vector2(window.innerWidth, window.innerHeight),
      //   this.scene,
      //   this.camera
      // )
      // this.composer.addPass(customOutline)

      this.selectiveCustomOutline = new SelectiveCustomOutlinePass(
        new THREE.Vector2(window.innerWidth, window.innerHeight),
        this.scene,
        this.camera
      )
      // this.composer.addPass(this.selectiveCustomOutline)

      // Antialias pass.
      this.effectFXAA = new ShaderPass(FXAAShader)
      this.effectFXAA.uniforms['resolution'].value.set(
        1 / window.innerWidth,
        1 / window.innerHeight
      )
      // this.composer.addPass(this.effectFXAA)

      // this.composer.addPass(this.thresholdPass)
      this.composer.addPass(this.comicalConvertPass)
      this.composer.addPass(this.selectiveCustomOutline)
      this.composer.addPass(this.effectFXAA)
      */
      
      this.clock = new THREE.Clock()
      const delta = this.clock.getDelta()

      // const textureForToonShader = THREE.ImageUtils.loadTexture(['/img/texture/toon.png'])
      // // const textureForToonShader = THREE.ImageUtils.loadTexture('[https://wgld.org/s/sample_035/toon.png'])
      // // const textureForToonShader = new THREE.TextureLoader().load('/img/texture/toon.png')
      
      // const toonShaderMaterial = createToonShaderMaterial({
      //   globalLight: this.light, 
      //   texture: textureForToonShader
      // })
      // toonShaderMaterial.morphTargets = true

      // const toonMaterial = new THREE.MeshToonMaterial({　//toon materialを使うと簡単にトゥーンレンダリングっぽくなる。オプションは適当に。
      //   transparent:true,
      //   opacity:1,
      //   color: 0xff0000,
      //   shininess: 1
      // })
      // toonMaterial.outlineParameters = {
      //   thickness: 0.007,
      //   color: new THREE.Color(0x0000ff),
      //   alpha: 10,
      //   visible: true,
      //   keepAlive: true
      // }

      // var mToonMat = new THREE.MToonMaterial({
      //   color: 0xffffff,
      // })

      // const lingGeom = new THREE.TorusGeometry(0.4, 0.1, 32, 32)
      // const lingMaterial = new THREE.MeshBasicMaterial({color: 0x99ffff})
      // const lingMesh = new THREE.Mesh(lingGeom, lingMaterial)
      // const lingMesh = new THREE.Mesh(lingGeom, shaderMaterial)
      // lingMesh.traverse(node => node.applyOutline = true)
      // this.scene.add(lingMesh)

      // // this.scene.add(new OutlineMesh(lingMesh))      

      // const lingMesh2 = new THREE.Mesh(lingGeom, lingMaterial)
      // lingMesh2.position.x = 0.1
      // lingMesh2.position.z = 1
      // this.outlinedScene.add(lingMesh2)

      // this.effect = new OutlineEffect(this.renderer, {
      //   defaultThickness: 0.001,
      //   defaultColor: [0, 0, 0],
      //   defaultAlpha: 0.8,
      //   defaultKeepAlive: true // keeps outline material in cache even if material is removed from scene
      // })
      // this.effect.render(this.scene, this.camera)

      // const boxGeometry = new THREE.BoxGeometry(0.5, 0.5, 0.5)
      // const boxMaterial = new THREE.MeshBasicMaterial({color: 0x99ffff})
      // // const boxMaterial = new THREE.MeshBasicMaterial({color: 0x000000})
      // const box = new THREE.Mesh(boxGeometry, boxMaterial)
      // box.position.set(0.0, 0.0, 0.0)

      // box.add(
      //   new THREE.LineSegments(
      //     boxGeometry,
      //     new THREE.LineBasicMaterial({
      //       color: 'black',
      //       transparent: false,
      //       opacity: 0.5
      //     })
      //   )
      // )
      // this.scene.add(box)

      // const shimotsukiui = '/vrm/shimotsuki_ui_color.vrm'
      // const renasan = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F17f34482489d2?alt=media&token=75a3d159-ffdb-4277-8d3c-01e39a5c0652'
      // const yamaimai = 'https://firebasestorage.googleapis.com/v0/b/comicaroid-prod.appspot.com/o/USER%2FVrAa2N47BoeKQR2INDn43tEoUxE3%2FASSET%2Fvrm%2F17f783a0c7e31c?alt=media&token=e34d66de-3bf5-4449-ab66-5d30a6404c94'
      // const kazisan = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F1811538c44061.vrm?alt=media&token=50467138-97d4-4847-b7ca-5bb63b0e5f0f'
      // const usagikurage = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F180f204a59737.vrm?alt=media&token=0e0df19a-845e-4ed4-a96f-0fd23800af35'
      // const vrm1 = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/sample%2FVRM1_Constraint_Twist_Sample.vrm?alt=media&token=41cb8031-411b-42aa-a46b-f50bc6f0f6b3'
      // this.addVRMModel(vrm1)
      // this.addVRMModel(renasan)

      // this.addVRMModel()
      this.addGLTFModel()

      this.tick()
    },
    tick () {
      // this.renderer.clear()

      requestAnimationFrame(this.tick)

      const delta = this.clock.getDelta()

      // this.renderer.render(this.scene, this.camera)
      
      // this.composer.render(this.scene, this.camera)
      this.composer.render()

      // this.renderer.clearDepth()
      // this.camera.layers.set(0)
      // this.renderer.render(this.scene, this.camera)

      // this.renderer.autoClear = true
      // // this.renderer.clear()
      // this.renderer.render(this.scene, this.camera)

      // this.renderer.autoClear = false
      // this.renderer.clearDepth()
      // this.renderer.render(this.outlinedScene, this.camera)

      // this.effect.render(this.scene, this.camera)
      // this.renderer.render(this.scene, this.camera)

      // this.effect.setRenderTarget(this.composer.render)
      // this.effect.render(this.scene, this.camera)
      // this.composer.render()

      // this.renderer.clear()
      // this.renderer.render(this.scene, this.camera)
      // this.effect.render(this.outlinedScene, this.camera)

      // this.composer.render(this.scene, this.camera)
      // this.effect.render(this.outlinedScene, this.camera)

      if (this.stats) this.stats.update()
    },
    async addVRMModel (vrmPath) {
      // キャラクターをロード
      // const shimotsukiui = '/vrm/shimotsuki_ui_color.vrm'
      const renasan = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F17f34482489d2?alt=media&token=75a3d159-ffdb-4277-8d3c-01e39a5c0652'
      const yamaimai = 'https://firebasestorage.googleapis.com/v0/b/comicaroid-prod.appspot.com/o/USER%2FVrAa2N47BoeKQR2INDn43tEoUxE3%2FASSET%2Fvrm%2F17f783a0c7e31c?alt=media&token=e34d66de-3bf5-4449-ab66-5d30a6404c94'
      const kazisan = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F1811538c44061.vrm?alt=media&token=50467138-97d4-4847-b7ca-5bb63b0e5f0f'
      const usagikurage = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fvrm%2F180f204a59737.vrm?alt=media&token=0e0df19a-845e-4ed4-a96f-0fd23800af35'
      const gltf = await this.loadGLTFwithDracoLoader({ path: vrmPath })
      this.vrm = gltf.userData.vrm
      // this.vrm = await VRM.from(gltf).then(vrm => vrm)

      if (this.isVRM1({ vrm: this.vrm })) {
        this.vrm.scene.position.set(0.5, 0, 0)
      } else {
        this.vrm.scene.rotation.set(0, Math.PI, 0)
      }

      this.vrm.scene.userData.vrm = this.vrm
      // this.vrm.scene.traverse(node => node.applyOutline = false)
      this.targetObject = this.vrm.scene

      const boneNode = this.vrm.humanoid.getNormalizedBoneNode('head')
      boneNode.rotation.set(0, 1.4, 0)
      this.vrm.update(this.clock.getDelta())
      
      // VRM1.0はすでにSurprisedとか追加されているっぽい
      // this.addUnkownBlendshapeToVRM(this.vrm)

      // this.setOutlineToVRM({
      //   vrm: this.vrm,
      //   materials: gltf.userData.vrmMToonMaterials,
      //   delta: this.clock.getDelta(),
      //   outlineWidth: { cloth: 0.002, hair: 0.001, skin: 0.003 },
      //   // outlineWidth: { cloth: 0.2, hair: 0.1, skin: 0.2 },
      //   color: { r: 0, g: 0, b: 0, a: 0 }
      // })

      // TO DO: テクスチャ差し替えだけでも試してみる
      // MEMO: 白目のテクスチャを真っ白にすれば消えるかも？
      // node.name === 'bone'に関節の位置と回転が入っていそう
      
      // const exclusions = ['BlendShapeController', 'Bone', 'Group']
      // const invisibleFacebakedsInSkinnedMesh = [
      //   'Facebaked_1', // 瞳
      //   'Facebaked_2', // 目のキラキラ
      //   // 'Facebaked_3', // 顔の肌
      //   // 'Facebaked_4', // 白目？
      //   'Facebaked_5', // 下まつげ？
      //   'Facebaked_6', // 横まつげ
      //   'Facebaked_7', // 上まつげ
      //   // 'Facebaked_8', // ?
      //   // 'Facebaked', // ?
      // ]
      // this.vrm.scene.traverse(node => {
      //   if (!exclusions.includes(node.type)) {
      //     if (node.name) console.log(node.type + ':::', node.name)
      //     // if (node.name.includes('Facebaked_1')) node.visible = false
      //     // if (node.name.includes('Facebaked_2')) node.visible = false
      //     if (invisibleFacebakedsInSkinnedMesh.includes(node.name)) {
      //       node.visible = false
      //     }
      //   }
      // })

      const delta = this.clock.getDelta()

      // のっぺらぼうエフェクト
      // await this.hideEyes({ vrm: this.vrm, delta })
      // await this.showEyes({ vrm: this.vrm, delta })

      // 髪型の変形テスト
      // this.vrm.springBoneManager.springBoneGroupList.forEach(element => {    	
     	//   element.forEach((node, index) => {
      //   	// // this.applyWindForce(node)
      //     let vec = new THREE.Vector3(0, -1, 0)
      //     // // x:^ y:  z: <->
      //     // let euler
      //     // if (index % 100 === 0) {
      //     //   euler = new THREE.Euler(0, 0, 1 + Math.random(), 'XYZ')
      //     //   console.log('index:', index)
      //     // } else {
      //     //   euler = new THREE.Euler(0, 0, Math.random(), 'XYZ')
      //     // }
          
      //     const euler = new THREE.Euler(0, 0, 1.0, 'XYZ')
      //     vec.applyEuler(euler)

      //     let currentGravity = node.gravityDir
      //     currentGravity.add(vec)
      //     node.gravityDir = currentGravity.normalize()
      //     node.gravityPower = 100 // this.currentWindForce
      //   })
      // })
      // this.vrm.update(this.clock.getDelta())

      // this.updateHairWind({
      //   vrm: this.vrm,
      //   delta: this.clock.getDelta(),
      //   params: {
      //     vec: new THREE.Vector3(0.5, -1, 0),
      //     euler: new THREE.Euler(0, 0, 0, 'XYZ'),
      //     windForce: 100
      //   }
      // })

      // テクスチャのプレヴュー用コード
      // const canvasForTexture = await this.addFaceTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'bloodshed'
      // })
      // const geoForCheckTexture = new THREE.PlaneGeometry(1, 1)
      // const materialWithTexture = new THREE.MeshBasicMaterial({
      //   map: new THREE.CanvasTexture(canvasForTexture)
      // })
      // const planeMesh = new THREE.Mesh(geoForCheckTexture, materialWithTexture)
      // planeMesh.position.set(0.0, 0.5, 0.0)
      // this.scene.add(planeMesh)

      // テクスチャの張り替えテスト
      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'face-bloodshed'
      // })
      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'face-return-blood'
      // })
      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'face-sekimen'
      // })
      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'face-sekimen'
      // })
      // await this.removeCustomTextureFromVRM({
      //   vrm: this.vrm, delta: this.clock.getDelta(), removingTextureName: 'face-bloodshed'
      // })

      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'eye-white'
      // })
      // await this.addCustomTextureToVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), addingTextureName: 'eye-heart'
      // })
      // await this.removeCustomTextureFromVRM({ 
      //   vrm: this.vrm, delta: this.clock.getDelta(), removingTextureName: 'eye-crazy'
      // })

      // this.vrm.materials.map(mat => {
      //   console.log('name:', mat.name)
      // })
            
      // this.vrm.scene.traverse(child => {
      //   if (child.material) {
      //     const mat = child.material
      //     console.log('name:', child.name)
      //     if (child.name.includes('Face')) {
      //       if (child.material[0].name.includes('Face_00_SKIN')) {
      //         debugger
      //       }
      //     }
      //     // if (mat.name.includes('Face_00_SKIN') && !mat.name.includes('Outline')) {
      //     //   console.log('mat.name:', mat.name)
      //     //   child.material = new THREE.MeshBasicMaterial({color: 0xff0000})
      //     // }
      //   }
      // })

      this.scene.add(this.vrm.scene)
    },
    async addGLTFModel () {
      // meshNum 54 verticesNum: 2028000 fps: 60
      const cafe = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17f8fe9983221e.draco.gltf?alt=media&token=6c902fb5-1fc7-4539-8071-5d6a383dcb70'
      const bedRoom = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17f952d97d410f.draco.gltf?alt=media&token=40487ee8-e6a7-4d6f-8039-f70fda19053d'
      const warehouse = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17f9518c84a23f.draco.gltf?alt=media&token=e34ca22c-a06c-4069-9b06-7e43ca99e323'
      // meshNum: 99 verticesNum: 34328 fps: 60
      const mansion = 'https://firebasestorage.googleapis.com/v0/b/comicaroid-prod.appspot.com/o/USER%2FVrAa2N47BoeKQR2INDn43tEoUxE3%2FASSET%2Fdraco.gltf%2F17f9a68f7537e.draco.gltf?alt=media&token=6ed59cb2-2e95-425c-b2f1-278f6a2fd6d9'
      // meshNum 10 verticesNum: 17424 fps: 60
      const hallway = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17fb4b07a323c6.draco.gltf?alt=media&token=db7d87c5-8012-440b-8aa1-f14debff1e77'
      // meshNum: 21 verticesNum: 1428912 fps: 60
      const warehouse2 = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17fb4b87f4e26b.draco.gltf?alt=media&token=d5ce4540-177d-47f2-a718-777fa311e810'
      const container = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17fbbe74fa8166.draco.gltf?alt=media&token=66ceb18a-e192-4aba-95a2-d07b580964e7'
      const myroom = '/gltf/myroom.gltf'
      const tooBigTown = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F17fe670f1ad32.draco.gltf?alt=media&token=6ef6bc6c-0bf0-4577-a16a-d57e5a9cd2da'
      const exportedTown = '/gltf/exported_town.gltf'
      const exportedTown2 = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2Fnull%2FASSET%2Fdraco.gltf%2F180c362cee617d.draco.gltf?alt=media&token=2742b851-4f1c-40ec-894f-0a6368cfe7c8'
      // meshNum: 1357 verticesNum: 93150 fps: 60
      const exportedTown3 = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F180c3862d38394.draco.gltf?alt=media&token=26246f37-a054-4ff2-8017-8c9473b23880'
      // meshNum: 197 verticesNum: 744381 fps: 60
      const yusukesanRoom = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F18146e4db252b.draco.gltf?alt=media&token=6ac1d11d-41e9-4a2e-aa40-0cf9cc8d87c7'
      // meshNum: 421 verticesNum: 977880 fps: 22
      const schoolByYusuke = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F1827feb7fa51e0.draco.gltf?alt=media&token=9d7d7415-de71-419d-8027-9d77054f6db7'
      const school = 'https://firebasestorage.googleapis.com/v0/b/comicaroid-prod.appspot.com/o/USER%2FVrAa2N47BoeKQR2INDn43tEoUxE3%2FASSET%2Fdraco.gltf%2F180d28843a9249.draco.gltf?alt=media&token=42fd4187-37c4-4598-a251-6edf9d2af51b'
      const schoolDesc = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F182a7c303ff206.draco.gltf?alt=media&token=85ca3783-e369-4a0e-8936-ab0d9dfe9e97'
      const schoolChair = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F1827fffba871d5.draco.gltf?alt=media&token=3c9c3cc3-6571-4a35-a0dd-cc4c17837ab6'
      const familyRestaurant = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F182e79b125b237.draco.gltf?alt=media&token=66f85405-fe7f-4a47-9226-d16fa152a749'
      const cinema = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F182f2409dbd114.draco.gltf?alt=media&token=3dcf7a49-566a-405f-8e9d-79f0d9474214'

      // for ccbt model test
      const scannedRoom = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/USER%2FY7GGg05QmJRsQFNtiBL3W2z1KH52%2FASSET%2Fdraco.gltf%2F193d7ec1c3b2dd.draco.gltf?alt=media&token=dad56924-ca97-459e-8b58-8290eb322f19'

      // gltfをロード
      let myGltf = await this.loadGLTFwithDracoLoader({path: schoolChair})
      // let myGltf = await this.loadGLTFwithDracoLoader({path: container})
      // myGltf.scene = this.mergeObject(myGltf.scene)

      myGltf.scene = this.mergeObjectByModelSize({ object: myGltf.scene })
      myGltf.scene.userData.isTopParentGroup = true
      myGltf.scene.traverse(node => node.applyOutline = true)

      this.gltf = myGltf
      // myGltf.scene.rotation.set(0, 1.3, 0)
      // myGltf.scene.position.set(0, 0, 4.0)

      // const textureLoader = new THREE.TextureLoader()
      // let textureNum = 0
      // myGltf.scene.traverse(async (node) => {
      //   if (node.type === 'Mesh') {
      //     if (node.material.map) {
      //       node.material.dispose()
      //       // const bmp = node.material.map.image
      //       // const canvas = document.createElement('canvas')
      //       // canvas.width = bmp.width / 100
      //       // canvas.height = bmp.height / 100
      //       // const ctx = canvas.getContext('bitmaprenderer')
      //       // ctx.transferFromImageBitmap(bmp)
      //       // const blob = await new Promise((res) => canvas.toBlob(res))
      //       // console.log('blob:', blob)

      //       // const texture = textureLoader.load(blob)
      //       // const material = new THREE.MeshStandardMaterial({
      //       //   map: texture
      //       // })

      //       // node.material = material
      //       node.material.needsUpdate = true
      //       node.material.map.needsUpdate = true

      //       console.log('node.material.map:', node.material.map.image)

      //       textureNum++
      //     }
      //   }
      // })
      // console.log('textureNum:', textureNum)      

      // const mergedGLTFGroup = this.mergeObject(myGltf.scene)

      const box3 = new THREE.Box3().setFromObject(myGltf.scene)

      const wSize = box3.max.x - box3.min.x
      // const initialScale = 1.0 / this.initialSize3dStage // サイズをthis.initialSize3dStageにする
      // const initialScale = 1.0 / wSize // サイズを1.0にする
      const initialScale = 4.0 / wSize // サイズを4.0にする
      myGltf.scene.scale.set(initialScale, initialScale, initialScale)
      console.log('initialScale:', initialScale)

      const modelPositionOffset = box3.getCenter(new THREE.Vector3())
      console.log('modelPositionOffset:', modelPositionOffset)
      
      myGltf.scene.position.set(
        -modelPositionOffset.x * initialScale,
        -modelPositionOffset.y * initialScale,
        -modelPositionOffset.z * initialScale
      )

      const wrapGLTFGroup = new THREE.Group()
      wrapGLTFGroup.add(myGltf.scene)

      this.scene.add(wrapGLTFGroup)
      
      // this.outlinedScene.add(wrapGLTFGroup)
      console.log('wrapGLTFGroup:', wrapGLTFGroup)  

      // gltf exporter test
      // const link = document.createElement('a')
      // link.style.display = 'none'
      // document.body.appendChild(link)
      // function save(blob, filename) {
      //   link.href = URL.createObjectURL(blob)
      //   link.download = filename
      //   link.click()
      //   // URL.revokeObjectURL( url ); breaks Firefox...
      // }
      // function saveString(text, filename) {
      //   save(new Blob( [ text ], { type: 'text/plain' } ), filename)
      // }
      // function saveArrayBuffer( buffer, filename ) {
      //   save(new Blob( [ buffer ], { type: 'application/octet-stream' } ), filename)
      // }

      // const exporter = new GLTFExporter()
      // exporter.parse(
      //   wrapGLTFGroup,
      //   // called when the gltf has been generated
      //   (gltf) => {
      //     console.log(gltf)
      //     // downloadJSON(gltf)
      //     if (gltf instanceof ArrayBuffer) {
      //       saveArrayBuffer(gltf, 'result.glb')
      //     } else {
      //       const output = JSON.stringify(gltf, null, 2)
      //       console.log(output)
      //       saveString(output, 'result.gltf')
      //     }
      //   },
      //   // called when there is an error in the generation
      //   (error) => {
      //     console.log('An error happened:', error)
      //   }
      //   // options
      // )

      console.log('myGltf:', myGltf.scene)

      // 線画を追加
      const lineGroup = this.createLineGeometoryToGroup({
        group: myGltf.scene, edgeDegreeThrehold: 80
      })
      this.scene.add(lineGroup)

      // this.addMargineBoxForRaycaster(wrapGLTFGroup, 'gltf')
    },
    addMargineBoxForRaycaster (sceneModel, format) {
      // raycansterの当たり判定用のボックスを追加
      const box3 = new THREE.Box3().setFromObject(sceneModel)
      const cubeSize = box3.getSize(new THREE.Vector3())
      const cubeGeom = new THREE.BoxGeometry(cubeSize.x / 2, cubeSize.y, cubeSize.z / 2)
      // const cubeGeom = new THREE.BoxGeometry(cubeSize.x * 2, cubeSize.y * 2, cubeSize.z * 2)
      const cubeMat = new THREE.MeshBasicMaterial({color: 0x000000})
      const cubeMesh = new THREE.Mesh(cubeGeom, cubeMat)
      if (sceneModel.userData.modelPositionOffset) {
        const offset = sceneModel.userData.modelPositionOffset
        cubeMesh.position.set(offset.x, offset.y, offset.z)
      }
      // cubeMesh.visible = false
      if (format === 'vrm') cubeMesh.position.y = cubeSize.y / 2

      const boxGroup = new THREE.Group()
      boxGroup.position.copy(sceneModel.position)
      boxGroup.rotation.copy(sceneModel.rotation)
      // boxGroup.scale.copy(sceneModel.scale)
      boxGroup.add(cubeMesh)
      this.scene.add(boxGroup)
      // this.scene.add(cubeMesh)
      console.log('boxGroup:', boxGroup)
    },
    onResize () {
      if (this.onResizeTimer) clearTimeout(this.onResizeTimer)
      this.onResizeTimer = setTimeout(this.resizeCanvas, 400)
    },
    resizeCanvas () {
      this.canvasSize = {
        width: this.$el.clientWidth,
        height: this.$el.clientHeight
      }
      if (this.renderer && this.camera) {
        // カメラのアスペクト比を正す
        this.camera.aspect = this.canvasSize.width / this.canvasSize.height
        this.camera.updateProjectionMatrix()

        const pixelRatio = this.renderer.getPixelRatio()
        this.renderer.setPixelRatio(pixelRatio)
        this.renderer.setSize(this.canvasSize.width, this.canvasSize.height)
        this.resizeComposer({ 
          canvasSize: this.canvasSize, renderer: this.renderer
        })
        // this.resizeComposer(this.canvasSize)
        // this.composer.setSize(this.canvasSize.width, this.canvasSize.height)
        // this.effectFXAA.setSize(this.canvasSize.width, this.canvasSize.height)
        // this.selectiveCustomOutline.setSize(this.canvasSize.width, this.canvasSize.height)
      }
    },
    async glbCompression () {
      const io = new WebIO()
        .registerExtensions([DracoMeshCompression])
        .registerDependencies({
          'draco3d.encoder': await new DracoEncoderModule(),
          'draco3d.decoder': await new DracoDecoderModule()
        })
      // Load an uncompressed GLB file.
      // const document = await io.read('/gltf/sp.glb')
      const glbPath = '/gltf/sp.glb' // '/vrm/minna_ai_comic.vrm'
      const document = await io.read(glbPath)

      // const reader = new FileReader()
      // reader.readAsArrayBuffer(glbPath)
      // await new Promise(resolve => reader.onload = () => resolve())
      // const GLBArrayBuffuer = reader.result
      // const GLBUint8Array = new Uint8Array(GLBArrayBuffuer)
      // const document = await io.readBinary(GLBUint8Array)

      // Configure compression settings.
      document.createExtension(DracoMeshCompression)
        .setRequired(true)
        .setEncoderOptions({
          method: DracoMeshCompression.EncoderMethod.EDGEBREAKER,
          encodeSpeed: 5,
          decodeSpeed: 5
        })
      
      // Create compressed GLB, in an ArrayBuffer.
      const dracoArrayBuffer = await io.writeBinary(document) // ArrayBuffer
      const dracoBlob = new Blob([dracoArrayBuffer])
      const dracoGLTF = URL.createObjectURL(dracoBlob)
      const fileId = this.getUniqueStr()
      const dracoFile = new File(
        [dracoBlob],
        `${fileId}.draco.gltf`,
        { type: 'application/octet-stream' }
      )
      console.log('dracoFile:', dracoFile)
    },
    getOrbitControllParams () {
      const polarAngle = this.orbitControls.getPolarAngle()
      const azimuthalAngle = this.orbitControls.getAzimuthalAngle()
      const distance = this.orbitControls.getDistance()
      const position = this.orbitControls.position0
      console.log({ polarAngle, azimuthalAngle, distance, position })
    },
    async changeFile (e) {
      const files = e.target.files || e.dataTransfer.files
      console.log('files:', files)
      const file = files[0]

      // const inputFile = this.$refs.inputFile
      // const fileURL = URL.createObjectURL(inputFile)
      // console.log('fileURL:', fileURL)

      const blobURL = URL.createObjectURL(file)

      // const fileReader = new FileReader()
      // const fileURL = fileReader.readAsDataURL(file)
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      await new Promise(resolve => fileReader.onload = () => resolve())
      const fileURL = fileReader.result
      
      const path = 'https://firebasestorage.googleapis.com/v0/b/v-comic-dev.appspot.com/o/sample%2F3d_model%2Fscene.gltf?alt=media&token=2701b3c8-dbc6-4118-9ff2-c3535a619b50'
      const myGltf = await this.loadGLTFwithDracoLoader({ path })

    //   const exporter = new GLTFExporter()
    //   exporter.parse(
    //     myGltf.scene,
    //     function (gltf) {
    //       console.log(gltf)
    //       const json = downloadJSON(gltf)
    //       debugger
    //     },
    //     // called when there is an error in the generation
    //     function (error) {
    //       console.log('An error happened')
    //     }
    //   )
    }
  }
}
</script>
